/* HOPERY Geschichte: Einblenden, Jahreszahl, Schwarzweiß-Überblendung, Duftauswahl */
(function () {
  if (window.__hoperyStory) return;
  window.__hoperyStory = true;
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  if (hasIO && !reduce) root.classList.add('hs-js');

  function init(scope) {
    scope = scope || document;
    var els = [].slice.call(scope.querySelectorAll('.hs-rise:not(.is-in)'));
    if (!hasIO || reduce) {
      els.forEach(function (e) { e.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var sib = [].slice.call(e.target.parentNode.children).filter(function (x) { return x.classList.contains('hs-rise'); });
          var i = Math.max(0, sib.indexOf(e.target));
          e.target.style.transitionDelay = Math.min(i, 5) * 75 + 'ms';
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (e) { io.observe(e); });
      setTimeout(function () { els.forEach(function (e) { e.classList.add('is-in'); }); }, 4000);
    }

    scope.querySelectorAll('.hs-story').forEach(function (story) {
      var yb = story.querySelector('[data-hs-year]'), yn = story.querySelector('[data-hs-name]');
      if (!yb || !hasIO) return;
      var so = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting || yb.textContent === e.target.dataset.year) return;
          yb.style.opacity = 0;
          setTimeout(function () { yb.textContent = e.target.dataset.year; if (yn) yn.textContent = e.target.dataset.name; yb.style.opacity = 1; }, reduce ? 0 : 180);
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      story.querySelectorAll('.hs-st').forEach(function (s) { so.observe(s); });
    });

    scope.querySelectorAll('[data-hs-fade]').forEach(function (f) {
      if (!hasIO) { f.classList.add('is-on'); return; }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { f.classList.toggle('is-on', e.isIntersecting); });
      }, { rootMargin: '-30% 0px -30% 0px' }).observe(f);
    });

    scope.querySelectorAll('[data-hs-scents]').forEach(function (sec) {
      var btns = sec.querySelectorAll('[data-hs-scent]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          sec.querySelectorAll('[data-hs-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-hs-panel') !== b.getAttribute('data-hs-scent'); });
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var b = e.target;
    if (b && b.hasAttribute('data-hs-scent')) b.click();
  });
})();
